import React from 'react';
import { getStreakEmoji, getMilestoneProgress } from '../utils/streaks';

export default function StreakBadge({ streak, bestStreak, color }) {
  const emoji = getStreakEmoji(streak);
  const { progress, next, daysToGo, maxed, top } = getMilestoneProgress(streak);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">Current Streak</p>
          <div className="flex items-baseline gap-2">
            <span className="text-3xl font-bold" style={{ color }}>
              {streak}
            </span>
            <span className="text-gray-500 dark:text-gray-400">
              day{streak !== 1 ? 's' : ''}
            </span>
            {emoji && <span className="text-2xl">{emoji}</span>}
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500 dark:text-gray-400">Best</p>
          <span className="text-xl font-semibold text-gray-700 dark:text-gray-300">
            {bestStreak}
          </span>
        </div>
      </div>

      {/* Next milestone progress */}
      {streak > 0 && (
        <div>
          <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mb-1">
            {maxed ? (
              <span>{top.emoji} {top.label}+ — legendary streak!</span>
            ) : (
              <>
                <span>Next: {next.emoji} {next.label}</span>
                <span>{daysToGo} day{daysToGo !== 1 ? 's' : ''} to go</span>
              </>
            )}
          </div>
          <div className="h-2 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-500"
              style={{ width: `${Math.min(progress, 100)}%`, backgroundColor: color }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
